<cm-profile-avatar class="avatar-profile" [imageUrl]="profile.image" [placeholder]="profile.avatarPlaceholder" />

@if (isLoggedAsProfile) {
  <div class="info">
    <span class="active-profile-name">{{ profile.origin.first_name + ' ' + profile.origin.last_name }}</span>
    <span class="active-profile-logged-as">logged in as {{ profile.role }}</span>
    <span class="active-profile-logged-as">{{ profile.first_name + ' ' + profile.last_name }}</span>
  </div>
} @else {
  <div class="info">
    <span class="active-profile-name">{{ profile.first_name + ' ' + profile.last_name }}</span>
    <span class="active-profile-role">
      {{ profile.role }}
      @if (profile.organization_name) {
        at {{ profile.organization_name }}
      }
    </span>
  </div>
}

<cm-user-profile-callout
  class="profile-callout"
  (close)="closeProfileCalloutHandler()"
  (mouseleave)="onMouseLeaveEvent()"
  (mouseover)="onProfileMouseOver()"
  [hidden]="!showProfileCallout"
/>
